import { render, staticRenderFns } from "./TcHeader.vue?vue&type=template&id=2570e00c&"
import script from "./TcHeader.vue?vue&type=script&lang=js&"
export * from "./TcHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2570e00c')) {
      api.createRecord('2570e00c', component.options)
    } else {
      api.reload('2570e00c', component.options)
    }
    module.hot.accept("./TcHeader.vue?vue&type=template&id=2570e00c&", function () {
      api.rerender('2570e00c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcHeader.vue"
export default component.exports